module.exports = __webpack_public_path__ + "static/img/Invitation-Blue.0574471.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Invitation-Blue.png
// module id = D4T2
// module chunks = 1